import { useEffect, useCallback } from "react";
import { useSSE } from "../context/SSEContext";

// Custom hook for pages to easily consume SSE updates
const useSSESubscription = (pageId, messageHandler, dependencies = []) => {
  const { subscribe, isConnected, error, lastEventTime, conflictDetector } =
    useSSE();

  const wrappedHandler = useCallback(
    (message, conflict) => {
      // Let each page decide what messages it cares about
      messageHandler(message, conflict);
    },
    [messageHandler, ...dependencies],
  );

  useEffect(() => {
    // Subscribe to SSE updates
    const unsubscribe = subscribe(pageId, wrappedHandler);

    // Cleanup on unmount
    return unsubscribe;
  }, [pageId, subscribe, wrappedHandler]);

  return {
    isConnected,
    error,
    lastEventTime,
    conflictDetector,
  };
};

export default useSSESubscription;
